module.exports = __webpack_public_path__ + "static/media/shape.b1b4cae6.svg";